import React from 'react'

import Target from '../../static/images/icons/target.svg'
import Rocket from '../../static/images/icons/rocket.svg'

const Mission = () => {
  return (
    <div className='mission'>
      <div className='container'>
        <dov className='row'>
          <div className='col-lg-6 left'>
            <img src={Target} data-aos='zoom-out' data-aos-delay='200' />
            <div className='head'>Vision</div>

            <p>
              To become leading Integrated Water and Waste Management Company,
              with triple bottom line ethos.
            </p>
          </div>
          <div className='col-lg-6 right'>
            <img src={Rocket} data-aos='fade-up' data-aos-delay='200' />
            <div className='head'>Mission</div>
            <p>
              <ul>
                <li>
                  To contribute significantly in improving lives and health
                  standard of rural and semi-urban India by providing clean and
                  Hygienic water.
                </li>
                <li>
                  Built sustainable and scalable business through innovative
                  models.
                </li>
                <li>Focus on optimal bottom line with moderate risk.</li>
                <li>Socio-enviromental impact is the core of our business.</li>
                <li>Provide quality, reliable, cost effective solutions.</li>
                <li>Align business model with Govt. policies.</li>
              </ul>
            </p>
          </div>
        </dov>
      </div>
    </div>
  )
}

export default Mission
